import { z } from 'zod'

export const SearchKeywordSchema = z.object({
  eventType: z.enum(['search-keyword']),
  keyword: z.string(),
  dataCount: z.object({
    regions: z.number(),
    subways: z.number(),
    landmarks: z.number(),
    total: z.number(),
  }),
})

export type SearchKeywordEvent = z.infer<typeof SearchKeywordSchema>

export enum MarkerType {
  REGION = 'region',
  SUBWAY = 'subway',
  LANDMARK = 'landmark',
}

export const ClickKeywordSchema = z.object({
  eventType: z.enum(['click-keyword']),
  keyword: z.string(),
  type: z.nativeEnum(MarkerType),
  dataCount: z.number(),
  markerName: z.string(),
  selectedIndex: z.number(),
})

export type ClickKeywordEvent = z.infer<typeof ClickKeywordSchema>
